/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { ChromePicker } from "@hello-pangea/color-picker";
import { Box, ClickAwayListener, InputAdornment, Popper, StandardTextFieldProps, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";

interface SettingsItemTextProps extends StandardTextFieldProps {
    prefix?: string;
    label?: string;
    type: string;
    startAdornment?: string;
    value?: any;
    onChange: (value: any) => void;
}

const SettingsItemText = ({
    onChange,
    value,
    prefix,
    label,
    type,
    startAdornment,
    ...props
}: SettingsItemTextProps) => {
    const [internalValue, setInternalValue] = useState(value);
    const [active, setActive] = useState(false);
    const anchorRef = useRef<HTMLElement>();

    useEffect(() => {
        let val = value;
        if (type === "color" || type === "background") val = `rgba(${Object.values(value)})`;
        setInternalValue(val);
    }, [value, type]);

    return (
        <Box
            ref={anchorRef}
            sx={{ width: "100%", position: "relative" }}
            onClick={() => {
                setActive(true);
            }}
        >
            {(type === "color" || type === "background") && active ? (
                <ClickAwayListener onClickAway={() => setActive(false)}>
                    <Popper open={active} anchorEl={anchorRef.current} placement="bottom-start">
                        <Box
                            className="color-picker-overlay"
                            sx={{
                                position: "absolute",
                                zIndex: 99999,
                                top: "calc(100% + 5px)",
                                left: 1,
                            }}
                        >
                            <Box
                                className="color-picker-background"
                                sx={{
                                    position: "fixed",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    cursor: "pointer",
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setActive(false);
                                }}
                            />
                            <ChromePicker
                                color={value}
                                onChange={(color: any) => {
                                    onChange(color.rgb);
                                }}
                            />
                        </Box>
                    </Popper>
                </ClickAwayListener>
            ) : null}
            <TextField
                variant="filled"
                size="small"
                fullWidth
                label={label}
                value={internalValue || ""}
                onKeyDown={(e) => {
                    if (type === "color" || type === "background") {
                        e.preventDefault();
                        return;
                    }
                }}
                onKeyUp={(e) => {
                    if (type === "color" || type === "background") {
                        e.preventDefault();
                        return;
                    }
                    //if (e.key === "Enter") {
                    onChange((e.target as any).value);
                    // }
                }}
                onChange={(e) => {
                    setInternalValue(e.target.value);
                }}
                InputProps={{
                    disableUnderline: true,
                    startAdornment: ["color", "background"].includes(type) ? (
                        <InputAdornment
                            position="start"
                            sx={{
                                mt: "2px",
                                mr: "8px",
                            }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    display: "inline-block",
                                    height: "0.75rem",
                                    width: "0.75rem",
                                    borderRadius: "100%",
                                }}
                                style={{
                                    background: internalValue,
                                }}
                            />
                        </InputAdornment>
                    ) : startAdornment ? (
                        <InputAdornment position="start">{startAdornment}</InputAdornment>
                    ) : null,
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                {...props}
            />
        </Box>
    );
};

export default SettingsItemText;
